import Hero from "@/components/home/Hero";
import CapabilityMarquee from "@/components/home/CapabilityMarquee";
import Services from "@/components/home/Services";
import WhyBytevora from "@/components/home/WhyBytevora";
import Solutions from "@/components/home/Solutions";
import Process from "@/components/home/Process";
import Engineering from "@/components/home/Engineering";
import AboutPreview from "@/components/home/AboutPreview";
import FinalCTA from "@/components/home/FinalCTA";

export default function HomePage() {
  return (
    <main id="top">
      <Hero />
      <CapabilityMarquee />
      <Services />
      <WhyBytevora />
      <Solutions />
      <Process />
      <Engineering />
      <AboutPreview />
      <FinalCTA />
    </main>
  );
}
